
// // src/components/Sidebar.jsx
// import {
//   Home,
//   ShieldCheck,
//   Building2,
//   History,
//   SendHorizontal,
//   Blocks,
//   Settings,
// } from "lucide-react";

// export default function Sidebar({ active, onItemClick }) {
//   const mainItems = [
//     { name: "Overview", icon: Home },
//     { name: "Super Admin", icon: ShieldCheck },
//     { name: "Organization", icon: Building2 },
//     { name: "Transactions", icon: History },
//     // { name: "Fast transfer", icon: SendHorizontal },
//   ];

//   const bottomItems = [
//     // { name: "UI Components", icon: Blocks },
//     { name: "Settings", icon: Settings },
//   ];

//   return (
//     <aside
//       className="
//         w-64 flex flex-col h-screen shadow-2xl transition-colors duration-300
//         bg-secondary-bg border-r border-card-border
//         dark:bg-secondary-bg dark:border-card-border
//       "
//     >
//       {/* Logo */}
//       <div className="p-6 border-b border-card-border dark:border-card-border">
//         <div className="flex items-center gap-3">
//           <span
//             className="
//               text-2xl font-bold bg-gradient-to-r from-accent-orange-400 to-accent-orange-600 
//               bg-clip-text text-transparent
//             "
//           >
//             ONE DESK
//           </span>
//         </div>
//       </div>

//       {/* Main Navigation */}
//       <nav className="flex-1 px-4 py-8 space-y-1.5 overflow-y-auto">
//         {mainItems.map((item) => {
//           const Icon = item.icon;
//           const isActive = active === item.name;

//           return (
//             <button
//               key={item.name}
//               onClick={() => onItemClick(item.name)}
//               className={`
//                 group relative w-full flex items-center gap-4 px-5 py-3.5 
//                 rounded-r-2xl text-base font-medium transition-all duration-200
//                 ${
//                   isActive
//                     ? "text-primary-text font-semibold border-l-4 border-accent-orange-500 bg-gradient-to-r from-accent-orange-900/60 to-transparent shadow-md"
//                     : "text-secondary-text hover:bg-accent-orange-950/40 hover:text-primary-text"
//                 }
//                 dark:${isActive 
//                   ? "text-primary-text bg-gradient-to-r from-accent-orange-900/60 to-transparent" 
//                   : "text-secondary-text hover:bg-accent-orange-950/50 hover:text-primary-text"}
//               `}
//             >
//               <Icon
//                 className={`w-5 h-5 ${
//                   isActive 
//                     ? "text-accent-orange-400" 
//                     : "text-secondary-text group-hover:text-accent-orange-400"
//                 } dark:${isActive ? "text-accent-orange-400" : "text-secondary-text group-hover:text-accent-orange-300"}`}
//               />
//               <span>{item.name}</span>

//               {isActive && (
//                 <div className="absolute inset-y-0 left-0 w-2 bg-accent-orange-600/30 blur-sm" />
//               )}
//             </button>
//           );
//         })}
//       </nav>

//       {/* Bottom Section - FIXED */}
//       <div className="p-4 border-t border-card-border dark:border-card-border mt-auto">
//         {bottomItems.map((item) => {
//           const Icon = item.icon;
//           const isActive = active === item.name;

//           return (
//             <button
//               key={item.name}
//               onClick={() => onItemClick(item.name)}           // ← THIS WAS MISSING
//               className={`
//                 w-full flex items-center gap-4 px-5 py-3 rounded-xl 
//                 text-base font-medium transition-all duration-200
//                 ${
//                   isActive
//                     ? "text-primary-text bg-gradient-to-r from-accent-orange-900/60 to-transparent border-l-4 border-accent-orange-500 shadow-md"
//                     : "text-secondary-text hover:bg-accent-orange-950/40 hover:text-primary-text"
//                 }
//                 dark:${isActive 
//                   ? "text-primary-text bg-gradient-to-r from-accent-orange-900/60 to-transparent" 
//                   : "text-secondary-text hover:bg-accent-orange-950/50 hover:text-primary-text"}
//               `}
//             >
//               <Icon
//                 className={`w-5 h-5 ${
//                   isActive 
//                     ? "text-accent-orange-400" 
//                     : "text-secondary-text group-hover:text-accent-orange-400"
//                 } dark:${isActive ? "text-accent-orange-400" : "text-secondary-text group-hover:text-accent-orange-300"}`}
//               />
//               <span>{item.name}</span>
//             </button>
//           );
//         })}
//       </div>
//     </aside>
//   );
// }

// // src/components/Sidebar.jsx
// import {
//   Home,
//   ShieldCheck,
//   Building2,
//   History,
//   Settings,
// } from "lucide-react";

// export default function Sidebar({ active, onItemClick }) {
//   const mainItems = [
//     { name: "Overview", icon: Home },
//     { name: "Super Admin", icon: ShieldCheck },
//     { name: "Organization", icon: Building2 },
//     { name: "Transactions", icon: History },
//   ];

//   const bottomItems = [
//     { name: "Settings", icon: Settings },
//   ];

//   return (
//     <aside
//       className="
//         w-64 flex flex-col h-screen shadow-2xl transition-colors duration-300
//         bg-secondary-bg border-r border-card-border
//         dark:bg-secondary-bg dark:border-card-border
//       "
//     >
//       {/* Logo Section with Light & Dark Mode Support */}
//       <div className="p-6 border-b border-card-border dark:border-card-border">
//         <div className="flex items-center gap-3">
          
//           {/* Light Mode Logo */}
//           <img
//             src="/assets/images/Logo.png"
//             alt="OneDesk Logo"
//             className="h-10 w-auto object-contain block dark:hidden"
//           />
          
//           {/* Dark Mode Logo - You need to add this file too */}
//           <img
//             src="/assets/images/onedesk.png"   // ← Create or rename this
//             alt="OneDesk Logo Dark"
//             className="h-10 w-auto object-contain hidden dark:block"
//           />

//           {/* Optional: Text beside logo */}
//          <div className="flex flex-col">
//             <h1 className="text-2xl font-bold leading-tight">
//               <span className="text-accent-orange-600">ONE</span> DESK
//             </h1>
//             <span className="text-[10px] font-medium text-secondary-text">
//               Everything In One Place
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Main Navigation */}
//       <nav className="flex-1 px-4 py-8 space-y-1.5 overflow-y-auto">
//         {mainItems.map((item) => {
//           const Icon = item.icon;
//           const isActive = active === item.name;

//           return (
//             <button
//               key={item.name}
//               onClick={() => onItemClick(item.name)}
//               className={`
//                 group relative w-full flex items-center gap-4 px-5 py-3.5 
//                 rounded-r-2xl text-base font-medium transition-all duration-200
//                 ${
//                   isActive
//                     ? "text-primary-text font-semibold border-l-4 border-accent-orange-500 bg-gradient-to-r from-accent-orange-900/60 to-transparent shadow-md"
//                     : "text-secondary-text hover:bg-accent-orange-950/40 hover:text-primary-text"
//                 }
//               `}
//             >
//               <Icon
//                 className={`w-5 h-5 ${
//                   isActive 
//                     ? "text-accent-orange-400" 
//                     : "text-secondary-text group-hover:text-accent-orange-400"
//                 }`}
//               />
//               <span>{item.name}</span>

//               {isActive && (
//                 <div className="absolute inset-y-0 left-0 w-2 bg-accent-orange-600/30 blur-sm" />
//               )}
//             </button>
//           );
//         })}
//       </nav>

//       {/* Bottom Section */}
//       <div className="p-4 border-t border-card-border dark:border-card-border mt-auto">
//         {bottomItems.map((item) => {
//           const Icon = item.icon;
//           const isActive = active === item.name;

//           return (
//             <button
//               key={item.name}
//               onClick={() => onItemClick(item.name)}
//               className={`
//                 w-full flex items-center gap-4 px-5 py-3 rounded-xl 
//                 text-base font-medium transition-all duration-200
//                 ${
//                   isActive
//                     ? "text-primary-text bg-gradient-to-r from-accent-orange-900/60 to-transparent border-l-4 border-accent-orange-500 shadow-md"
//                     : "text-secondary-text hover:bg-accent-orange-950/40 hover:text-primary-text"
//                 }
//               `}
//             >
//               <Icon
//                 className={`w-5 h-5 ${
//                   isActive 
//                     ? "text-accent-orange-400" 
//                     : "text-secondary-text group-hover:text-accent-orange-400"
//                 }`}
//               />
//               <span>{item.name}</span>
//             </button>
//           );
//         })}
//       </div>
//     </aside>
//   );
// }

// src/components/Sidebar.jsx
import { useNavigate, useLocation } from "react-router-dom";
import {
  Home,
  ShieldCheck,
  Building2,
  History,
  Settings,
} from "lucide-react";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const mainItems = [
    { name: "Overview", icon: Home, path: "/" },
    { name: "Super Admin", icon: ShieldCheck, path: "/super-admin" },
    { name: "Organization", icon: Building2, path: "/organization" },
    { name: "Transactions", icon: History, path: "/transactions" },
  ];

  const bottomItems = [
    { name: "Settings", icon: Settings, path: "/settings" },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <aside
      className="
        w-64 flex flex-col h-screen shadow-2xl transition-colors duration-300
        bg-secondary-bg border-r border-card-border
        dark:bg-secondary-bg dark:border-card-border
      "
    >
      {/* Logo Section */}
      <div className="p-6 border-b border-card-border dark:border-card-border">
        <div className="flex items-center gap-3">
          <img
            src="/assets/images/Logo.png"
            alt="OneDesk Logo"
            className="h-10 w-auto object-contain block dark:hidden"
          />
          <img
            src="/assets/images/onedesk.png"
            alt="OneDesk Logo Dark"
            className="h-10 w-auto object-contain hidden dark:block"
          />

           <div className="flex flex-col">          <h1 className="text-2xl font-bold leading-tight">
              <span className="text-accent-orange-600">ONE</span> DESK
             </h1>
             <span className="text-[10px] font-medium text-secondary-text">
               Everything In One Place
             </span>
         </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="flex-1 px-4 py-8 space-y-1.5 overflow-y-auto">
        {mainItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.name}
              onClick={() => navigate(item.path)}
              className={`
                group relative w-full flex items-center gap-4 px-5 py-3.5 
                rounded-r-2xl text-base font-medium transition-all duration-200
                ${active
                  ? "text-primary-text font-semibold border-l-4 border-accent-orange-600 bg-gradient-to-r from-accent-orange-600 "
                  : "text-secondary-text hover:bg-accent-orange-950/40 hover:text-primary-text"
                }
              `}
            >
              <Icon
                className={`w-5 h-5 ${
                  active ? "text-accent-orange-600" : "text-secondary-text group-hover:text-accent-orange-600"
                }`}
              />
              <span>{item.name}</span>

              {active && (
                <div className="absolute inset-y-0 left-0 w-2 bg-accent-orange-600/30 blur-sm" />
              )}
            </button>
          );
        })}
      </nav>

      {/* Bottom Section */}
      <div className="p-4 border-t border-card-border dark:border-card-border mt-auto">
        {bottomItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.name}
              onClick={() => navigate(item.path)}
              className={`
                w-full flex items-center gap-4 px-5 py-3 rounded-xl 
                text-base font-medium transition-all duration-200
                ${active
                  ? "text-primary-text bg-gradient-to-r from-accent-orange-900/60 to-transparent border-l-4 border-accent-orange-500 shadow-md"
                  : "text-secondary-text hover:bg-accent-orange-950/40 hover:text-primary-text"
                }
              `}
            >
              <Icon
                className={`w-5 h-5 ${
                  active ? "text-accent-orange-400" : "text-secondary-text group-hover:text-accent-orange-400"
                }`}
              />
              <span>{item.name}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
}